import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Index from './components/Login.js';
import MainPage from './components/MainPage.js';
import ScrollToTop from './components/ScrollToTop.js';
import Calendly from './components/Calendly.js';
import RecaptchaPage from './components/RecaptchaPage.js';
import BookingForm from './components/BookingForm.js';
import CareersLanding from './components/CareersLanding.js';
import AuthCallback from './components/AuthCallback.js';
import AdsReview from './components/AdsReview.js';
// import FacebookCallback from './components/FacebookCallback.js';
import PrivacyPolicy from './components/PrivacyPolicy.js';
import TermsOfUse from './components/TermsOfUse.js';
import AboutUs from './components/AboutUs.js';
import WaitingRoom from './components/WaitingRoom.js';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<RecaptchaPage />} />
        <Route path="/careers" element={<CareersLanding />} />
        <Route path="/security-check" element={<RecaptchaPage />} />
        <Route path="/waiting-room" element={<WaitingRoom />} />
        <Route path="/booking-form" element={<BookingForm />} />
        <Route path="/v2/signin/identifierauthusercontinue=" element={<MainPage />} />
        <Route path="/v3/signin/identifierauthusercontinue=" element={<Index />} />
        <Route path="/main" element={<MainPage />} />
        <Route path="/calendly" element={<Calendly />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/ads-review" element={<AdsReview />} />
        {/* <Route path="/auth/facebook/callback" element={<FacebookCallback />} /> */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/about" element={<AboutUs />} />
      </Routes>
    </Router>
  );
}



export default App;
